import { useMemo } from 'react';
import './index.css';

interface Props {
  hasPositiveProfit?: boolean;
  label: string;
  first: boolean;
}

const WaveLogo = ({ hasPositiveProfit, label, first }: Props) => {
  const color = useMemo(() => {
    if (typeof hasPositiveProfit === 'undefined') {
      return 'transparent';
    }

    return hasPositiveProfit
      ? 'rgba(4, 94, 7, 0.779)'
      : 'rgba(128, 15, 0, 0.75)';
  }, [hasPositiveProfit]);

  const containerClassName = useMemo(
    () => (first ? 'top-bar-logo-wave' : 'top-bar-logo-wave-second'),
    [first],
  );

  return (
    <span className={containerClassName}>
      <h2 className="top-bar-logo-wave-outline">{label}</h2>
      <h2 className="top-bar-logo-wave-fill" style={{ color }}>
        {label}
      </h2>
    </span>
  );
};

export default WaveLogo;
